/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

// Images
import historiaImg from "assets/images/historia.jpg";

// Framer Motion
import { motion } from "framer-motion";

function Information() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="flag"
                    title="Misión"
                    description="Proveer productos y servicios de alta calidad con atención personalizada y soluciones confiables."
                  />
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: "100%" }}
                    transition={{ duration: 1 }}
                    style={{
                      height: "2px",
                      background: `linear-gradient(30deg, transparent, ${
                        isDarkMode ? "#ffffff" : "#235eacff"
                      }, transparent)`,
                      margin: "1rem 0",
                    }}
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="visibility"
                    title="Visión"
                    description="Ser la empresa líder en la región norte de México, reconocida por calidad e innovación."
                  />
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: "100%" }}
                    transition={{ duration: 1 }}
                    style={{
                      height: "2px",
                      background: `linear-gradient(90deg, transparent, ${
                        isDarkMode ? "#ffffff" : "#1A73E8"
                      }, transparent)`,
                      margin: "1rem 0",
                    }}
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="thumb_up"
                    title="Valores"
                    description="Calidad, Innovación tecnológica, Compromiso, Responsabilidad social, Honestidad y confianza."
                  />
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: "100%" }}
                    transition={{ duration: 1 }}
                    style={{
                      height: "2px",
                      background: `linear-gradient(30deg, transparent, ${
                        isDarkMode ? "#ffffff" : "#235eacff"
                      }, transparent)`,
                      margin: "1rem 0",
                    }}
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="local_shipping"
                    title="Logística"
                    description="Desde 2015 contamos con sistema propio de distribución para cubrir toda la zona norte."
                  />
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: "100%" }}
                    transition={{ duration: 1 }}
                    style={{
                      height: "2px",
                      background: `linear-gradient(90deg, transparent, ${
                        isDarkMode ? "#ffffff" : "#1A73E8"
                      }, transparent)`,
                      margin: "1rem 0",
                    }}
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={historiaImg}
              title="Nuestra Historia"
              description="Nacimos en 2008 en CDMX como una pequeña empresa de suministros de oficina. Gracias a la confianza de nuestros clientes, expandimos nuestro catálogo a servicios de impresión, viniles y tintas especiales, convirtiéndonos en un proveedor integral para empresas y particulares."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "contáctanos",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
